import React, { useState } from "react";
import VisualRepresentation from "./VisualRepresentation";

const ProvocationDisplay = ({ provocations, onRemix, theme }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isSourceVisible, setIsSourceVisible] = useState(false);

  if (!provocations || provocations.length === 0) {
    return null;
  }

  const handleNext = () => {
    if (activeIndex < provocations.length - 1) {
      setActiveIndex(activeIndex + 1);
      setIsSourceVisible(false); // Hide source when changing
    }
  };

  const handlePrevious = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
      setIsSourceVisible(false); // Hide source when changing
    }
  };

  const toggleSourceVisibility = () => {
    setIsSourceVisible(!isSourceVisible);
  };

  const activeProvocation = provocations[activeIndex];

  return (
    <div className="provocation-display mt-8">
      <h2 className="text-2xl font-bold mb-6 dark:text-white">Your Provocations</h2>
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
        <div className="flex justify-between items-center mb-4">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Provocation {activeIndex + 1} of {provocations.length}
          </p>
          <div className="flex space-x-2">
            <button
              onClick={handlePrevious}
              disabled={activeIndex === 0}
              className="px-3 py-1 rounded bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 transition-colors"
            >
              Previous
            </button>
            <button
              onClick={handleNext}
              disabled={activeIndex === provocations.length - 1}
              className="px-3 py-1 rounded bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 transition-colors"
            >
              Next
            </button>
          </div>
        </div>

        <p className="text-xl text-gray-800 dark:text-gray-100 mb-4">
          {activeProvocation.provocation}
        </p>
        <div className="mb-4 border dark:border-gray-700 rounded-lg overflow-hidden w-full h-64">
          <VisualRepresentation code={activeProvocation.visualization} theme={theme} />
        </div>

        <div className="flex items-center space-x-4">
          <button
            onClick={() => onRemix(activeProvocation.provocation)}
            className="bg-secondary-600 text-black px-4 py-2 rounded-md hover:bg-secondary-700 dark:bg-secondary-500 dark:hover:bg-secondary-600 dark:text-white transition-colors"
          >
            Remix Visual
          </button>
          <button
            onClick={toggleSourceVisibility}
            className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:underline"
          >
            {isSourceVisible ? "Hide Source" : "View Source"}
          </button>
        </div>

        {isSourceVisible && (
          <div className="mt-4 p-4 bg-gray-50 dark:bg-gray-900 rounded-md overflow-x-auto">
            <pre className="text-sm text-gray-800 dark:text-gray-200 whitespace-pre-wrap">
              <code>{activeProvocation.visualization}</code>
            </pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProvocationDisplay;
